export enum BioSampleMetaType {
  ALIQUOT_V1 = 'ALIQUOT_V1',
}
